import { useDispatch, useSelector } from 'react-redux'
import Pagination from 'components/pagination/Pagination'
import { setAdGroupsPage } from 'features/crux/tracker/detail/trackerDetailSlice'
import Table from 'components/table/Table'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'
import { useHistory, useParams } from 'react-router-dom'

const AdGroups = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { accountId: adAccountId } = useParams()
  const { content, isLoading, page, totalElements } = useSelector(
    state => state.tracker.detail.adGroups
  )
  return (
    <div className="audience_detail">
      <div className="tbl_top">
        <p className="txt_noti">
          해당 픽셀 &amp; SDK를 사용중인 광고그룹을 확인할 수 있습니다.
        </p>
      </div>
      <div className="tblg2_wrap">
        <Table
          className="tbl_g2"
          caption="광고그룹 표"
          loading={isLoading}
          emptyMessage="연동 중인 광고그룹이 없습니다.">
          <Table.Head>
            <Table.Column title="캠페인" width={205} />
            <Table.Column title="광고그룹" />
            <Table.Column title="광고그룹 상태" width={235} />
          </Table.Head>
          <Table.Body>
            {content.map(({ id, name, status, campaignName }) => (
              <Table.Row key={id} rowId={id}>
                <td>
                  <div className="inner_tbl">{campaignName}</div>
                </td>
                <td>
                  <div className="inner_tbl">
                    <span className="limit_line">
                      <NoneAnchor
                        onClick={() =>
                          history.push(
                            `/${adAccountId}/gotoDashboard?adGroupId=${id}`
                          )
                        }
                        className="link_txt limit_line">
                        {name}
                      </NoneAnchor>
                    </span>
                  </div>
                </td>
                <td>
                  <div className="inner_tbl">
                    <p className="ad_state ico_state">
                      <span
                        className={classNames({
                          ico_on: status === 'ON',
                          ico_off: status === 'OFF',
                        })}>
                        {status}
                      </span>
                      {status === 'ON' ? '운영 가능' : '운영 불가(OFF)'}
                    </p>
                  </div>
                </td>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {totalElements > 0 && (
        <div className="paging_wrap">
          <div className="inner_paging">
            <Pagination
              current={page}
              total={totalElements}
              onChange={v => dispatch(setAdGroupsPage(v))}
            />
          </div>
        </div>
      )}
    </div>
  )
}
export default AdGroups
